import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {DeviceService} from '@app/core/services/device.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageBoxIcon, ModalButton, ModalButtons, ModalCloseReason, ModalRef} from '@app/core/models/modal-ref';
import {ExtensionDevice} from '@app/core/models/misc';
import {NGXLogger} from 'ngx-logger';
import { TranslateService } from '@ngx-translate/core';
import {ApiService} from '@app/core/services/api.service';
import {ModalService} from '@app/core/services/modal.service';
import {ProfilesService} from '@app/core/services/profiles.service';
import {Observable, of} from 'rxjs';
import {DeviceType} from '@app/core/models/device';
import {environment} from '../../../../environments/environment';
import {ScgHttpWrapper} from '@app/core/injectables/scg-http-wrapper';
import {ScgSharedFactoryService} from '@app/core/services/scg-shared-factory.service';
import {ModalExportFilenameData, ModalfilenameComponent} from '@app/shared/modals/modalfilename/modalfilename.component';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-modalprofilesentry',
  templateUrl: './modalprofilesentry.component.html',
  styleUrls: ['./modalprofilesentry.component.scss']
})
export class ModalprofilesentryComponent implements OnInit {


  @ViewChild('savename') searchElement: ElementRef;
  @ViewChild('FileSelectInputDialog') FileSelectInputDialog: ElementRef;

  public profileState = 0;
  public errorCaption = '';
  public loadCaption = '';
  public saveCaption = '';
  public overwriteCaption = '';
  public radioSelection = 0;
  public selectError = false;
  public saveError = false;
  public filename = '';
  public isLoading = false;
  public wantLocal = false;
  public isAdvanced = false;

  public selectedItem = '';
  public profileItem: any[];
  public fileName?: string[];
  public fileId?: string[];
  public localFile: FileList;

  constructor(
    private route: ActivatedRoute,
    private device: DeviceService,
    private apiProfiles: ProfilesService,
    public scgShared: ScgSharedFactoryService,
    private translate: TranslateService,
    private scgHttp: ScgHttpWrapper,
    private modal: ModalService,
    private modalRef: ModalRef,
    private log: NGXLogger,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {

    this.prepareTranslations();

    this.modalRef.onWantsClose.subscribe(({reason, cancelClose, close}) => {
      if (reason === ModalCloseReason.Cancel) {
        this.log.info('modal canceled');
        // Special case cancel on Save Exists message
        if (this.profileState === ProfileState.Exists) {
          this.profileState = ProfileState.Save;
          this.filename = '';
          this.loadProfileList();
          cancelClose();
          return;
        }
        // Normal case: close modal, user pressed cancel
        close();
        return;
      }

      if (reason === ModalCloseReason.Ok) {
        this.log.info('ok pressed');

        // No radio selected
        if (this.profileState === ProfileState.Entry && this.radioSelection === ProfileState.Entry) {
          this.selectError = true;
          cancelClose();
          return;
        }

        // Want local load
        if (this.wantLocal && this.profileState === ProfileState.Entry && this.radioSelection === ProfileState.Load) {
          const e: HTMLElement = this.FileSelectInputDialog.nativeElement;
          e.click();
          cancelClose();
          return;
        }


        if (this.profileState === ProfileState.Exists) {
          this.modalRef.setButtonLoading(ModalButton.Ok, true);
          this.apiProfiles.profileSave(this.filename).subscribe((innerResponse) => {
            close();
            this.showSaveSuccessMessage();
          });
          return;
       }

        // Entry -> load selected
        if (this.profileState === ProfileState.Entry && this.radioSelection === ProfileState.Load) {
          this.modalRef.modalConfig.title = this.loadCaption;
          this.filename = '';
          this.selectError = false;
          this.profileState = ProfileState.Load;
          this.loadProfileList();
          cancelClose();
          return;
        }

        // Entry -> save selected
        if (this.profileState === ProfileState.Entry && this.radioSelection === ProfileState.Save) {
          this.modalRef.modalConfig.title = this.saveCaption;
          this.profileState = ProfileState.Save;
          this.filename = '';
          this.loadProfileList();
          this.focusSavename();
          cancelClose();
          return;
        }

        // Load -> Error none selected
        if (this.profileState === ProfileState.Load && this.filename === '') {
            this.selectError = true;
            cancelClose();
            return;
        }

        // Load -> entry selected (ok)
        if (this.profileState === ProfileState.Load && this.filename !== '') {
          this.profileState = ProfileState.LoadOverwrite;
          cancelClose();
          return;
        }

        // Load -> entry selcted, display are you sure msg
        if (this.profileState === ProfileState.LoadOverwrite) {

          if (this.wantLocal) {
            // Case local file
            this.modalRef.setButtonLoading(ModalButton.Ok, true);
            this.importGo(this.localFile);
            cancelClose();
            return;
          } else {
            // Case server profile
            this.modalRef.setButtonLoading(ModalButton.Ok, true);
            this.apiProfiles.profileLoad(this.filename).subscribe((innerResponse) => {
              window.location.reload();
              close();
              return;
            });
          }
        }


        // Save -> nothing entered
        if (this.profileState === ProfileState.Save && this.filename === '') {
          this.saveError = true;
          this.focusSavename();
          cancelClose();
          return;
        }

        // Save with savename entered
        if (this.profileState === ProfileState.Save && this.filename !== '') {
          this.saveError = false;
          cancelClose();
          if (this.wantLocal) {
            // want save local
            close();
            this.exportLocal(this.filename);
          } else {
            // want save in portal
            this.apiProfiles.profileExists(this.filename).subscribe((response) => {
              if (response.result === true) {
                this.profileState = ProfileState.Exists;
                return;
              } else {
                this.modalRef.setButtonLoading(ModalButton.Ok, true);
                this.apiProfiles.profileSave(this.filename).subscribe((innerResponse) => {
                  close();
                  this.showSaveSuccessMessage();
                });
              }
            });
            return;
          }
        }

        if (this.profileState === ProfileState.Error) {
          close();
          return;
        }

        cancelClose();
      }

      });

  }

public onClickRadioLoad() {
    this.selectError = false;
    this.radioSelection = ProfileState.Load;
}


public onClickRadioSave() {
  this.selectError = false;
  this.radioSelection = ProfileState.Save;
}

public loadProfileList() {
  this.isLoading = true;
  this.apiProfiles.getProfileList().subscribe((response) => {
    this.isLoading = false;
    this.log.info('profilelist=', response);
    this.profileItem = (response as any);
  });
}

public deleteSelectedProfile() {

  const postdata = {fileName: this.filename};

  this.isLoading = true;
  this.apiProfiles.deleteProfile(postdata).subscribe((response) => {
    this.log.info('deleteProfile=', response);
    this.loadProfileList();
  });
}

  public import(files: FileList) {
    // Pre-Step, change to LoadOverwrite dialog
    this.localFile = files;
    this.profileState = ProfileState.LoadOverwrite;
  }


  public importGo(files: FileList) {

    this.isLoading = true;
    this.log.info('imöport files=', files);
    const file = files.item(0);
    const formData = new FormData();
    formData.append('file', file);

    let observable = of(null);

    if (this.device.activeDevice.device.type === DeviceType.CC) {
      if (this.device.activeDevice?.username == null) {
        this.log.error('Could not get username for CC API request');
        return new Observable(null);
        this.isLoading = false;
      }

      observable = this.scgHttp.post<any>(
        environment.apiUrl + this.device.activeDevice.username + '/service/import/ccboth',
        formData
      );
    } else if (this.device.activeDevice.device.type === DeviceType.CB) {

      observable = this.scgHttp.post<any>(
        environment.apiUrl + 'service/import/v2/cb',
        formData
      );
    }

    observable.subscribe({
      next: () => {
        this.modalRef.close(ModalCloseReason.Ok);
        window.location.reload();
      },
      error: () => {
        this.isLoading = false;
        this.errorImportMsg();
      }
    });
  }

public setSavename(value) {
    this.selectedItem = value;    // load case
    this.filename = value;
}

public focusSavename() {
  setTimeout(() => { // this will make the execution after the above boolean has changed
    this.searchElement.nativeElement.focus();
  }, 250);
}

public resetError() {
    this.selectError = false;
}


private prepareTranslations() {
  this.translate.get(['MESSAGE.ERROR'], ['PROFILES.LOAD']).subscribe(
    text => {
      this.errorCaption = text['MESSAGE.ERROR'];
    }
  );
  this.translate.get(['PROFILES.LOAD']).subscribe(
    text => {
      this.loadCaption = text['PROFILES.LOAD'];
    }
  );
  this.translate.get(['PROFILES.SAVE']).subscribe(
    text => {
      this.saveCaption = text['PROFILES.SAVE'];
    }
  );
  this.translate.get(['PROFILES.LOAD_OVERWRITE']).subscribe(
    text => {
      this.overwriteCaption = text['PROFILES.LOAD_OVERWRITE'];
      this.overwriteCaption = this.overwriteCaption.replace('%%DEVICE%%', this.device.activeDevice.device.name);
    }
  );
}




  public exportLocal(downloadFilename: string) {

    downloadFilename = downloadFilename.toLowerCase();
    this.log.info('export download-file:' + downloadFilename);
    const fileExt = downloadFilename.substr(downloadFilename.length - 4);
    if (fileExt !== '.ccf') downloadFilename = downloadFilename + '.ccf';

    this.downloadExportFile(this.device.activeDevice.device.type).subscribe((response) => {
      this.log.info('export fileExt=' + fileExt + '|response=', response);
      const fileData = JSON.stringify(response);
      const blob = new Blob([fileData], {
        type: 'text/json'
      });

      const url: string = window.URL.createObjectURL(blob);
      const anchor: HTMLAnchorElement = this.document.createElement('a');
      anchor.style.display = 'none';
      anchor.href = url;
      anchor.download = downloadFilename;
      anchor.click();

      setTimeout(() : void => {
        window.URL.revokeObjectURL(url);
      });

      this.showDownloadSuccessMsg();
      close();

    });

  }

  public toggleAdvanced() {
    this.isAdvanced = !this.isAdvanced;
  }

  private downloadExportFile(deviceType: number) {
    if (deviceType === DeviceType.CC) {
      if (this.device.activeDevice?.username == null) {
        this.log.error('Could not get username for CC API request');
        return new Observable(null);
      }
      // environment.apiUrl + this.device.activeDevice.username + '/
      return this.scgHttp.get<{ any }>(environment.apiUrl + this.device.activeDevice.username + '/service/export/cc');
    } else if (deviceType === DeviceType.CB) {
      return this.scgHttp.get<{ any }>(environment.apiUrl + 'service/export/cb');
    }
  }


  private showSaveSuccessMessage() {
    this.modal.showMessageBox({
      text: 'PROFILES.SAVE_SUCCESS',
      title: 'BUTTON.INFORMATION',
      buttons: ModalButtons.Ok,
      closeOnBackdropClick: false,
      defaultButton: ModalButton.Ok,
      icon: MessageBoxIcon.Information
    });
  }

  private showDownloadSuccessMsg() {
    this.modal.showMessageBox({
      text: 'MESSAGE.EXPORT_SUCCESS_1',
      title: 'MESSAGE.INFO',
      buttons: ModalButtons.Ok,
      closeOnBackdropClick: false,
      defaultButton: ModalButton.Ok,
      icon: MessageBoxIcon.None
    });
  }

  private errorImportMsg() {
    this.modal.showMessageBox({
      text: 'MESSAGE.IMPORTFAILED',
      title: 'MESSAGE.ERROR',
      buttons: ModalButtons.Ok,
      closeOnBackdropClick: false,
      defaultButton: ModalButton.Ok,
      icon: MessageBoxIcon.Warning
    });
  }

}


export enum ProfileState {
  Entry,
  Load,
  Save,
  Error = 4,
  Exists,
  LoadOverwrite = 6
}


